'use client';

import { Container } from '..';
import { useContext, useState } from 'react';
import { FoodListElement } from './FoodListElement';
import { FoodGlucoseSearchContext } from './context';
import styles from './GlucoseResponse.module.css';

const cx = (...args: Array<string | false | undefined | null>) =>
  args.filter(Boolean).join(' ');

export const GlucoseResponse = ({
  className,
  topFoods,
  bottomFoods,
}: {
  className?: string;
  topFoods: Array<unknown>;
  bottomFoods: Array<unknown>;
}) => {
  const FoodGlucoseDbClient = useContext(FoodGlucoseSearchContext);
  const [activeTab, setActiveTab] = useState('top');

  if (FoodGlucoseDbClient.searchResponse.length > 0) return null;

  const handletabClick = (e: any) => {
    console.log(e.target.value);
    setActiveTab(e.target.value);
  };

  return (
    <section className={cx(styles.root, className)}>
      <Container className={styles.parentContainer}>
        <div className={styles.content}>
          {/* both zones render; CSS shows one per viewport (useWindowSize is 0 on SSR) */}
          <div className={styles.foodZones}>
            <div className={cx(styles.zone, 'top-zone')}>
              <h2>Top Zone</h2>
              <div className={styles.foodItems}>
                {topFoods.map((e: any, i) => {
                  return (
                    <FoodListElement
                      key={i}
                      foodTitle={e.name}
                      foodPeakValue={e.average_peak_glucose_levels}
                      foodScore={Math.round(Number(e.average_score))}
                      foodSpikeTrend={e.spike_indicator}
                      mealTime={e.meal_timing_to_show_at}
                      href={{
                        pathname: `/ogdb/${e.url_friendly_name ?? e.food_id}/`,
                      }}
                    />
                  );
                })}
              </div>
            </div>
            <div className={cx(styles.zone, 'bottom-zone')}>
              <h2>Bottom zone</h2>
              <div className={styles.foodItems}>
                {
                  // TODO
                  bottomFoods.map((e: any, i) => {
                    return (
                      <FoodListElement
                        key={i}
                        foodTitle={e.name}
                        foodPeakValue={e.average_peak_glucose_levels}
                        foodScore={Math.round(Number(e.average_score))}
                        foodSpikeTrend={e.spike_indicator}
                        mealTime={e.meal_timing_to_show_at}
                        href={{
                          pathname: `/ogdb/${
                            e.url_friendly_name ?? e.food_id
                          }/`,
                        }}
                      />
                    );
                  })
                }
              </div>
            </div>
          </div>
          <div className={styles.mobileFoodZones}>
            <p className={styles.tag}>See what&apos;s trending</p>
            <div className={styles.tabs}>
              <button
                onClick={(e) => handletabClick(e)}
                className={
                  activeTab === 'top' ? cx(styles.tab, styles.active) : styles.tab
                }
                value="top"
              >
                Top Zone
              </button>
              <button
                onClick={(e) => handletabClick(e)}
                className={
                  activeTab === 'bottom'
                    ? cx(styles.tab, styles.active)
                    : styles.tab
                }
                value="bottom"
              >
                Bottom Zone
              </button>
            </div>
            {activeTab === 'top' ? (
              <div className={cx(styles.zone, 'mobile-top-zone')}>
                <div className={styles.foodItems}>
                  {
                    // TODO
                    topFoods.map((e: any, i) => {
                      return (
                        <div key={i} className={styles.foodItemCard}>
                          <FoodListElement
                            key={i}
                            foodTitle={e.name}
                            foodPeakValue={e.average_peak_glucose_levels}
                            foodScore={Math.round(e.average_score)}
                            foodSpikeTrend={e.spike_indicator}
                            mealTime={e.meal_timing_to_show_at}
                            href={{
                              pathname: `/ogdb/${
                                e.url_friendly_name ?? e.food_id
                              }`,
                            }}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            ) : (
              <div className={cx(styles.zone, 'mobile-bottom-zone')}>
                <div className={styles.foodItems}>
                  {
                    // TODO
                    bottomFoods.map((e: any, i) => {
                      return (
                        <div key={i} className={styles.foodItemCard}>
                          <FoodListElement
                            key={i}
                            foodTitle={e.name}
                            foodPeakValue={e.average_peak_glucose_levels}
                            foodScore={Math.round(e.average_score)}
                            foodSpikeTrend={e.spike_indicator}
                            mealTime={e.meal_timing_to_show_at}
                            href={{
                              pathname: `/ogdb/${
                                e.url_friendly_name ?? e.food_id
                              }`,
                            }}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
      {/* <div className="gradient-container" /> */}
    </section>
  );
};
